import { createAction } from "typesafe-actions";

export const RequestActionCreators = {
    clearHistory: createAction("CLEAR_HISTORY")<string, void>(),
};
